/**
 * Returns the minimum selectable date based on pastYears setting (0 to 20).
 * If pastYears is 0, returns Jan 1 of current year.
 * If pastYears is N (e.g. 3), returns Jan 1 of (currentYear - N).
 * Default fallback is 3 years past if unspecified.
 */
export const getMinDate = (pastYears?: number | boolean): Date => {
  const currentYear = new Date().getFullYear();
  if (pastYears === false) {
    return new Date(currentYear, 0, 1, 0, 0, 0, 0);
  }
  const years = typeof pastYears === "number" ? pastYears : 3;
  return new Date(currentYear - years, 0, 1, 0, 0, 0, 0);
};
